import React, { Fragment, useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { compose } from "redux";
import { CircularProgress } from "@material-ui/core";
import {
  REQUntHldListAuto,
  requestDisapproveClientAuto,
} from "./redux/actions";
import Table from "./table";
import { list_of_columns } from "./list_of_columns";
import { selectedObjectUuid } from "../../components/BreadCrumbs/redux/actions";
import {
  setCurrentCustomerUntHldDetail,
  CleanUpUntHldSrch,
} from "../AutoApproveDetail/redux/actions";

import Images from "../../utils/styles/images";
import { WarningModal } from "../../components/Modal";
import "./style.scss";
import Pagination from "./Pagination";
function AutoApprove(props) {
  const {
    REQUntHldListAuto,
    REQStrUntHldList,
    UntHldList,
    totalUntHldAct,
    requestDisapproveClientAuto,
    setCurrentCustomerUntHldDetail,
    CleanUpUntHldSrch,
    history,
  } = props;
  const columns = React.useMemo(() => list_of_columns, []);
  const [tSrch, SETxSrch] = useState("");
  const [tOpSrch, SETxOpSrch] = React.useState("Email");
  const [nPageIndex, SETxPageIndex] = useState(0);

  //Filter doc states
  const [filterStatus, setFilterStatus] = useState("");
  const [filterStatusMethod, setFilterStatusMethod] = useState("");
  //Filter Bank Status
  const [filterBankStatus, SetFilterBankStatus] = useState("");
  const [isAllBankStatusChecked, setIsAllBankStatusChecked] = useState(true);

  //Filter IdCard Status
  const [filterIdCardStatus, SetFilterIdCardStatus] = useState("");
  const [isAllIdCardStatusChecked, setIsAllIdCardStatusChecked] =
    useState(true);

  const [isAllAutoChecked, setIsAllAutoChecked] = useState(true);
  const [isAllAutoCheckedMethod, setIsAllAutoCheckedMethod] = useState(true);
  const [tSortH, SETtSortH] = useState("updated_at DESC");

  //Filter acc states
  //Filter convertuser states
  const [tFltConvertUsr, SETtFltConvertUsr] = useState("");
  const [isDefaultConvert, setIsDefaultConvert] = useState(true);

  const [isShow, setIsShow] = useState(false);
  const [clientRowData, setClientRowData] = useState({
    customerUuid: "",
    unitholderid: "",
    firstName: "",
    history: "",
  });

  const handleAllAutoStatusChange = () => {
    if (isAllAutoChecked == true) {
      setFilterStatus([]);
    } else if (isAllAutoChecked == false) {
      setFilterStatus([]);
    }
    // CALLxUntHld()
    setIsAllAutoChecked(!isAllAutoChecked);
  };

  // #region Filter : Unitholder Method
  const handleAllAutoStatusChangeMethod = () => {
    if (isAllAutoCheckedMethod == true) {
      setFilterStatusMethod([]);
    } else if (isAllAutoCheckedMethod == false) {
      setFilterStatusMethod([]);
    }
    // CALLxUntHld()
    setIsAllAutoCheckedMethod(!isAllAutoCheckedMethod);
  };
  // #endregion

  const handleAutoStatusChange = (status) => {
    setIsAllAutoChecked(false);
    let newStatuses = [...filterStatus];

    if (newStatuses.includes(status)) {
      newStatuses = newStatuses.filter((s) => s !== status);
    } else {
      newStatuses.push(status);
    }

    setFilterStatus(newStatuses);
  };

  // #region : handle change status :  Unitholder Method

  const handleAutoStatusChangeMethod = (status) => {
    setIsAllAutoCheckedMethod(false);
    let newStatuses = [...filterStatusMethod];

    if (newStatuses.includes(status)) {
      newStatuses = newStatuses.filter((s) => s !== status);
    } else {
      newStatuses.push(status);
    }

    setFilterStatusMethod(newStatuses);
  };

  const handleAllBankStatusChange = () => {
    if (isAllBankStatusChecked == true) {
      SetFilterBankStatus([]);
    } else if (isAllBankStatusChecked == false) {
      SetFilterBankStatus([]);
    }
    // CALLxUntHld()
    setIsAllBankStatusChecked(!isAllBankStatusChecked);
  };
  const handleBankStatusChange = (status) => {
    setIsAllBankStatusChecked(false);
    let newStatuses = [...filterBankStatus];

    if (newStatuses.includes(status)) {
      newStatuses = newStatuses.filter((s) => s !== status);
    } else {
      newStatuses.push(status);
    }

    SetFilterBankStatus(newStatuses);
  };

  // Handle iDCard status
  const handleAllIdCardStatusChange = () => {
    if (isAllIdCardStatusChecked == true) {
      SetFilterIdCardStatus([]);
    } else if (isAllIdCardStatusChecked == false) {
      SetFilterIdCardStatus([]);
    }
    // CALLxUntHld()
    setIsAllIdCardStatusChecked(!isAllIdCardStatusChecked);
  };

  const handleIdCardStatusChange = (status) => {
    setIsAllIdCardStatusChecked(false);
    let newStatuses = [...filterIdCardStatus];

    if (newStatuses.includes(status)) {
      newStatuses = newStatuses.filter((s) => s !== status);
    } else {
      newStatuses.push(status);
    }

    SetFilterIdCardStatus(newStatuses);
  };
  // #endregion

  // Handle docs

  // Handle Convert

  const CALLxUntHld = () => {
    CleanUpUntHldSrch();
    if (history.location.PageCurrent === undefined) {
      SETxPageIndex(0);
      console.log("IN IF");
      REQUntHldListAuto({
        page: "1",
        tSrch,
        tOpSrch,
        SortH: tSortH,
        status: isAllAutoChecked ? "1,2,3,5,6,0" : filterStatus.join(","),
        FilterBankStatus: isAllBankStatusChecked
          ? "1,2,3,0"
          : filterBankStatus.join(","),
        FilterIdCardStatus: isAllIdCardStatusChecked
          ? "1,2,3,0"
          : filterIdCardStatus.join(","),
        status_method: isAllAutoCheckedMethod
          ? "AUTO_APPROVE,MANUAL_APPROVE,-"
          : filterStatusMethod.join(","),
        FltConvertUsr: isDefaultConvert ? "0,1" : tFltConvertUsr.join(","),
      });
    } else {
      console.log("IN ELSE");
      let nPage = history.location.PageCurrent + 1;
      // SET value UI
      SETxOpSrch(history.location.UISearch.tOpSrch);
      SETxSrch(history.location.UISearch.tSrch);

      SETxPageIndex(history.location.PageCurrent);
      REQUntHldListAuto({
        page: nPage.toString(),
        tSrch: history.location.UISearch.tSrch,
        tOpSrch: history.location.UISearch.tOpSrch,
        status: isAllAutoChecked ? "1,2,3,5,6,0" : filterStatus.join(","),
        FilterBankStatus: isAllBankStatusChecked
          ? "1,2,3,0"
          : filterBankStatus.join(","),
        FilterIdCardStatus: isAllIdCardStatusChecked
          ? "1,2,3,0"
          : filterIdCardStatus.join(","),
        status_method: isAllAutoCheckedMethod
          ? "AUTO_APPROVE,MANUAL_APPROVE,-"
          : filterStatusMethod.join(","),
        SortH: tSortH,
        FltConvertUsr: isDefaultConvert ? "0,1" : tFltConvertUsr.join(","),
      });
      console.log("");
    }
  };

  useEffect(() => {
    CALLxUntHld();
  }, [
    filterStatus,
    filterStatusMethod,
    tSortH,
    filterBankStatus,
    filterIdCardStatus,
  ]);

  const SRCHxUntHld = () => {
    SETxPageIndex(0);
    REQUntHldListAuto({
      page: "1",
      tSrch,
      tOpSrch,
      status: isAllAutoChecked ? "1,2,3,5,6,0" : filterStatus.join(","),
      FilterBankStatus: isAllBankStatusChecked
        ? "1,2,3,0"
        : filterBankStatus.join(","),
      FilterIdCardStatus: isAllIdCardStatusChecked
        ? "1,2,3,0"
        : filterIdCardStatus.join(","),
      status_method: isAllAutoCheckedMethod
        ? "AUTO_APPROVE,MANUAL_APPROVE,-"
        : filterStatusMethod.join(","),
      FltConvertUsr: isDefaultConvert ? "0,1" : tFltConvertUsr.join(","),
    });
  };

  const SRCHxUsrActClr = () => {
    SETxSrch("");
    SETxPageIndex(0);
    REQUntHldListAuto({
      page: "1",
      tSrch: "",
      tOpSrch,
      status: isAllAutoChecked ? "1,2,3,5,6,0" : filterStatus.join(","),
      FilterBankStatus: isAllBankStatusChecked
        ? "1,2,3,0"
        : filterBankStatus.join(","),
      FilterIdCardStatus: isAllIdCardStatusChecked
        ? "1,2,3,0"
        : filterIdCardStatus.join(","),
      status_method: isAllAutoCheckedMethod
        ? "AUTO_APPROVE,MANUAL_APPROVE,-"
        : filterStatusMethod.join(","),
      FltConvertUsr: isDefaultConvert ? "0,1" : tFltConvertUsr.join(","),
    });
  };

  const sortMappings = {
    "SUBMISSION DATE": {
      ascending: "submission_at ASC",
      descending: "submission_at DESC",
    },
    "UPDATED AT": {
      ascending: "updated_at ASC",
      descending: "updated_at DESC",
    },
  };

  const setHeaderSort = (cell) => {
    if (sortMappings[cell]) {
      const newSortH =
        tSortH === sortMappings[cell].ascending
          ? sortMappings[cell].descending
          : sortMappings[cell].ascending;
      SETtSortH(newSortH);
    }
  };

  const RadioInput = ({ label, value, checked, setter }) => {
    return (
      <span>
        <input
          type="radio"
          checked={checked === value}
          onChange={() => {
            setter(value);
          }}
        />
        <span style={{ marginLeft: 0 }}>{label}</span>
      </span>
    );
  };

  const SETxActViewClick = (row) => {
    console.log("[SETxActViewClick]:", row.original);

    const unitholderDetails = {
      uuid: row.original.uuid,
      unitholderid: row.original?.unitholderId || row.original?.unitholder_id,
      unitholderMethod: row.original?.customer_unitholder_method,
      UsrAccountType: row.original.accounttype,
      NameTH: row.original.firstNameTh,
      UserName: row.original.username,
      PageCurrent: nPageIndex,
      UISearch: {
        tSrch: tSrch,
        tOpSrch: tOpSrch,
      },
    };

    // Save data to localStorage
    localStorage.setItem(
      "currentAutoApproveDetail",
      JSON.stringify(unitholderDetails)
    );
    console.log(
      "[SETxActViewClick] -> [unitholderDetails]:",
      unitholderDetails
    );
    setCurrentCustomerUntHldDetail(unitholderDetails);
    selectedObjectUuid(row.original.firstNameEn);
    history.push(
      `/AutoApproveDetail/${row.original.uuid}/UnitHolderID=${
        row.original?.unitholderId || row.original?.unitholder_id
      }`
    );
  };

  const handleActionClick = (row, actionName) => {
    if (
      actionName === "APPROVE" ||
      actionName === "REJECT" ||
      actionName === "CANCEL" ||
      actionName === "CREATING"
    ) {
      setCurrentCustomerUntHldDetail({
        uuid: row.uuid,
        unitholderid: row.unitholderId,
        UsrAccountType: row.accounttype,
        NameTH: row.firstNameTh,
        UserName: row.username,
        PageCurrent: nPageIndex,
        UISearch: {
          tSrch: tSrch,
          tOpSrch: tOpSrch,
        },
      });
      selectedObjectUuid(row.firstNameEn);

      history.push(
        `/UnitHolderDetail/${row.uuid}/UnitHolderID=${row.unitholderId}`
      );
    } else if (actionName === "DISAPPROVE") {
      setClientRowData({
        customerUuid: row.uuid,
        unitholderid: row.unitholder_id,
        firstName: row.first_name,
        UserName: row.username,
        history: history,
      });
      setIsShow(true);
    }
  };

  const SETxPageGo = (pnPageAt) => {
    let nPageAt = pnPageAt + 1;
    SETxPageIndex(pnPageAt);
    REQUntHldListAuto({
      page: nPageAt.toString(),
      tSrch,
      tOpSrch,
      SortH: tSortH,
      status: isAllAutoChecked ? "1,2,3,5,6,0" : filterStatus.join(","),
      FilterBankStatus: isAllBankStatusChecked
        ? "1,2,3,0"
        : filterBankStatus.join(","),
      FilterIdCardStatus: isAllIdCardStatusChecked
        ? "1,2,3,0"
        : filterIdCardStatus.join(","),
      status_method: isAllAutoCheckedMethod
        ? "AUTO_APPROVE,MANUAL_APPROVE,-"
        : filterStatusMethod.join(","),
      FltConvertUsr: isDefaultConvert ? "0,1" : tFltConvertUsr.join(","),
    });
  };
  const CALxPaging = () => {
    let nPageCnt = Math.ceil(totalUntHldAct / 10);
    return nPageCnt > 1 ? (
      <Pagination
        nPageIndex={nPageIndex}
        total={nPageCnt}
        gotoPage={SETxPageGo}
      />
    ) : null;
  };
  const GETxWidthSrch = () => {
    if (tOpSrch === "UUID") {
      return 450;
    } else {
      return 331;
    }
  };

  const SETxFltHeader = (cell) => {
    if (cell === "ACC. STATUS") {
      return (
        <div className="clients-header-sortby-autoapprove">
          <div className="clients-header-sortby-text-container-autoapprove">
            <p>{cell}</p>
            <img
              className="clients-header-sortby-img"
              src={Images.filer.filer}
              alt="down-arrow"
            />
          </div>

          <div
            className="clients-header-sortby-radio-container"
            style={{ height: 250 }}
          >
            <p>FILTER STATUS BY</p>
            <div className="clients-header-sortby-row">
              <input
                type="checkbox"
                value="ALL"
                name="all-doc"
                id="all-doc"
                checked={isAllAutoChecked}
                onChange={handleAllAutoStatusChange}
              />
              <label htmlFor="all-doc" className="checkbox-label">
                ALL
              </label>
            </div>

            <div className="clients-header-sortby-row">
              <input
                type="checkbox"
                value="APPROVE"
                name="approved-doc"
                id="approved-doc"
                checked={filterStatus.includes("2")}
                onChange={() => handleAutoStatusChange("2")}

                // end test
              />
              <label htmlFor="approved-doc">APPROVE</label>
            </div>
            <div className="clients-header-sortby-row">
              <input
                type="checkbox"
                value="PENDING"
                name="pending-doc"
                id="pending-doc"
                checked={filterStatus.includes("1")}
                onChange={() => handleAutoStatusChange("1")}

                // end test
              />
              <label htmlFor="pending-doc">PENDING</label>
            </div>
            {/*  <div className="clients-header-sortby-row">
              <input
                type="checkbox"
                value="REJECTED"
                name="rejected-doc"
                id="rejected-doc"
                checked={filterStatus.includes("REJECTED")}
                onChange={() => handleAutoStatusChange("REJECTED")}

                // end test
              />
              <label htmlFor="rejected-doc">REJECT</label>
            </div> */}

            {/* <div className="clients-header-sortby-row">
              <input
                type="checkbox"
                value="MANUAL"
                name="approved-doc"
                id="approved-doc"
                checked={filterStatus.includes("MANUAL")}
                onChange={() => handleAutoStatusChange("MANUAL")}

                // end test
              />
              <label htmlFor="approved-doc">MANUAL</label>
            </div> */}
          </div>
        </div>
      );
    }

    if (cell === "ACC. METHOD") {
      return (
        <div className="clients-header-sortby-autoapprove">
          <div className="clients-header-sortby-text-container-autoapprove">
            <p>{cell}</p>
            <img
              className="clients-header-sortby-img"
              src={Images.filer.filer}
              alt="down-arrow"
            />
          </div>

          <div
            className="clients-header-sortby-radio-container"
            style={{ height: 250 }}
          >
            <p>FILTER STATUS BY</p>
            <div className="clients-header-sortby-row">
              <input
                type="checkbox"
                value="ALL"
                name="all-method"
                id="all-method"
                checked={isAllAutoCheckedMethod}
                onChange={handleAllAutoStatusChangeMethod}
              />
              <label htmlFor="all-method" className="checkbox-label">
                ALL
              </label>
            </div>

            <div className="clients-header-sortby-row">
              <input
                type="checkbox"
                value="APPROVE"
                name="approved-method"
                id="approved-method"
                checked={filterStatusMethod.includes("AUTO_APPROVE")}
                onChange={() => handleAutoStatusChangeMethod("AUTO_APPROVE")}
              />
              <label htmlFor="approved-method">AUTO APPROVE</label>
            </div>
            <div className="clients-header-sortby-row">
              <input
                type="checkbox"
                value="PENDING"
                name="pending-method"
                id="pending-method"
                checked={filterStatusMethod.includes("MANUAL_APPROVE")}
                onChange={() => handleAutoStatusChangeMethod("MANUAL_APPROVE")}
              />
              <label
                htmlFor="pending-method"
                style={{
                  fontSize: 12,
                }}
              >
                MANUAL APPROVE
              </label>
            </div>
          </div>
        </div>
      );
    } else if (cell === "BANK STATUS") {
      return (
        <div className="clients-header-sortby">
          <div className="clients-header-sortby-text-container">
            <p>{cell}</p>
            <img
              className="clients-header-sortby-img"
              src={Images.filer.filer}
              alt="down-arrow"
            />
          </div>

          <div
            className="clients-header-sortby-radio-container"
            style={{ height: 210 }}
          >
            <p>FILTER STATUS BY</p>
            <div className="clients-header-sortby-row">
              <input
                type="checkbox"
                value="ALL"
                name="all-doc"
                id="all-doc"
                checked={isAllBankStatusChecked}
                onChange={handleAllBankStatusChange}
              />
              <label htmlFor="all-doc" className="checkbox-label">
                ALL
              </label>
            </div>

            <div className="clients-header-sortby-row">
              <input
                type="checkbox"
                value="Approved"
                name="approved-doc"
                id="approved-doc"
                checked={filterBankStatus.includes("2")}
                onChange={() => handleBankStatusChange("2")}
              />
              <label htmlFor="approved-doc">APPROVED</label>
            </div>

            <div className="clients-header-sortby-row">
              <input
                type="checkbox"
                value="Pending"
                name="pending-doc"
                id="pending-doc"
                checked={filterBankStatus.includes("1")}
                onChange={() => handleBankStatusChange("1")}
              />
              <label htmlFor="pending-doc">PENDING</label>
            </div>
            <div className="clients-header-sortby-row">
              <input
                type="checkbox"
                value="Rejected"
                name="rejected-doc"
                id="rejected-doc"
                checked={filterBankStatus.includes("3")}
                onChange={() => handleBankStatusChange("3")}
              />
              <label htmlFor="rejected-doc">REJECTED</label>
            </div>
            <div className="clients-header-sortby-row">
              <input
                type="checkbox"
                value="No Document"
                name="approved-doc"
                id="approved-doc"
                checked={filterBankStatus.includes("0")}
                onChange={() => handleBankStatusChange("0")}
              />
              <label htmlFor="approved-doc">NO ACCOUNT</label>
            </div>
          </div>
        </div>
      );
    } else if (cell === "ID CARD STATUS") {
      return (
        <div className="clients-header-sortby">
          <div className="clients-header-sortby-text-container">
            <p>{cell}</p>
            <img
              className="clients-header-sortby-img"
              src={Images.filer.filer}
              alt="down-arrow"
            />
          </div>

          <div
            className="clients-header-sortby-radio-container"
            style={{ height: 210 }}
          >
            <p>FILTER STATUS BY</p>
            <div className="clients-header-sortby-row">
              <input
                type="checkbox"
                value="ALL"
                name="all-doc"
                id="all-doc"
                checked={isAllIdCardStatusChecked}
                onChange={handleAllIdCardStatusChange}
              />
              <label htmlFor="all-doc" className="checkbox-label">
                ALL
              </label>
            </div>

            <div className="clients-header-sortby-row">
              <input
                type="checkbox"
                value="Approved"
                name="approved-doc"
                id="approved-doc"
                checked={filterIdCardStatus.includes("2")}
                onChange={() => handleIdCardStatusChange("2")}
              />
              <label htmlFor="approved-doc">APPROVED</label>
            </div>

            <div className="clients-header-sortby-row">
              <input
                type="checkbox"
                value="Pending"
                name="pending-doc"
                id="pending-doc"
                checked={filterIdCardStatus.includes("1")}
                onChange={() => handleIdCardStatusChange("1")}
              />
              <label htmlFor="pending-doc">PENDING</label>
            </div>
            <div className="clients-header-sortby-row">
              <input
                type="checkbox"
                value="Rejected"
                name="rejected-doc"
                id="rejected-doc"
                checked={filterIdCardStatus.includes("3")}
                onChange={() => handleIdCardStatusChange("3")}
              />
              <label htmlFor="rejected-doc">REJECTED</label>
            </div>
            <div className="clients-header-sortby-row">
              <input
                type="checkbox"
                value="No Document"
                name="approved-doc"
                id="approved-doc"
                checked={filterIdCardStatus.includes("0")}
                onChange={() => handleIdCardStatusChange("0")}
              />
              <label htmlFor="approved-doc">-</label>
            </div>
          </div>
        </div>
      );
    }
  };
  const handleModalGo = () => {
    if (isShow) {
      setIsShow(false);
      requestDisapproveClientAuto(clientRowData);
      CALLxUntHld();
    }
  };
  return (
    <Fragment>
      <WarningModal
        show={isShow}
        onHide={() => {
          setIsShow(false);
          setClientRowData({
            customerUuid: "",
            unitholderid: "",
            firstName: "",
            history: "",
          });
        }}
        onHandleGo={() => handleModalGo()}
        onHandleCancel={() => {
          setIsShow(false);
          setClientRowData({
            customerUuid: "",
            unitholderid: "",
            firstName: "",
            history: "",
          });
        }}
        type={"Disapprove"}
        status={"1"}
        title={"Are you sure you want to disapprove this unitholder?"}
      />

      <div className="button-create-container" style={{ marginBottom: 10 }}>
        <div style={{ height: 40 }} />

        {REQStrUntHldList ? (
          <div className="regisDevice-list-progress">
            <CircularProgress />
            <p className="regisDevice-list-progress-text">
              {REQStrUntHldList ? "Retrieving UnitHolder list..." : null}
            </p>
          </div>
        ) : null}
      </div>

      <div className="labelInput" style={{ marginLeft: 20, marginTop: 50 }}>
        <span className="labelInputText" style={{ width: 100 }}>
          Search By
        </span>
        <span style={{ paddingRight: 10 }}>:</span>
        <div
          className="usrAct-search"
          style={{ marginTop: 0, width: GETxWidthSrch() }}
        >
          <img
            src={Images.search.search}
            alt="search-icon"
            className="transactions-list-begin-search"
            onClick={() => SRCHxUntHld()}
          />
          <input
            placeholder={"Search by " + tOpSrch}
            className="usrAct-search-bar"
            value={tSrch}
            onChange={(event) => {
              SETxSrch(event.target.value.trim());
            }}
            onKeyDown={(event) => {
              if (event.keyCode === 13) {
                SRCHxUntHld();
              }
            }}
          />
          {tSrch && tSrch.length > 0 ? (
            <img
              src={Images.closeButton.close}
              alt="cancel-search"
              className="transactions-details-cancel-search"
              onClick={() => SRCHxUsrActClr()}
            />
          ) : null}
        </div>
      </div>
      <div
        className="clients-radio-container"
        style={{ marginLeft: 145, marginBottom: 20 }}
      >
        <RadioInput
          label="E-mail"
          value="Email"
          checked={tOpSrch}
          setter={SETxOpSrch}
        />{" "}
        <span style={{ marginRight: 20 }} />
        <RadioInput
          label="Username"
          value="Username"
          checked={tOpSrch}
          setter={SETxOpSrch}
        />
        <span style={{ marginRight: 20 }} />
        <RadioInput
          label="English Name"
          value="English Name"
          checked={tOpSrch}
          setter={SETxOpSrch}
        />
        <span style={{ marginRight: 20 }} />
        <RadioInput
          label="Thai Name"
          value="Thai Name"
          checked={tOpSrch}
          setter={SETxOpSrch}
        />
        <span style={{ marginRight: 20 }} />
        <RadioInput
          label="ID No. / Passport No."
          value="ID No. / Passport No."
          checked={tOpSrch}
          setter={SETxOpSrch}
        />
        <span style={{ marginRight: 20 }} />
        <RadioInput
          label="Mobile"
          value="Mobile"
          checked={tOpSrch}
          setter={SETxOpSrch}
        />
      </div>
      {}
      {REQStrUntHldList ? null : (
        <Table
          columns={columns}
          data={UntHldList || []}
          handleViewClick={SETxActViewClick}
          handleFltHeader={SETxFltHeader}
          handleActionClick={handleActionClick}
          handleActionHeaderClick={setHeaderSort}
          pageSelect={nPageIndex}
        />
      )}
      {REQStrUntHldList ? null : <CALxPaging />}
    </Fragment>
  );
}

const withConnect = connect(
  (state) => ({
    ...state.untHldListAutoReducer,
  }),
  {
    REQUntHldListAuto,
    setCurrentCustomerUntHldDetail,
    requestDisapproveClientAuto,
    // clear state in UntHldDdetail
    CleanUpUntHldSrch,
  }
);

export default compose(withConnect, withRouter)(AutoApprove);
